import React, { useEffect } from 'react';
import { useTranslation }   from 'react-i18next';
import DV                   from 'ts-data-validator';

import './scss.scss';

import Preloader         from '../../components/containers/preloader';
import Meta              from '../../components/meta';
import PageHeader        from '../../components/pageHeader';
import { useVacancies }  from '../../providers/vacancies';
import Notfound          from '../notfound/components/Notfound';
import { VacanciesItem } from './components';
import RenderButton      from '../../components/buttons/base/RenderButton';
import ContactUs         from '../../components/buttons/ContactUs';

const Vacancies = function() {
  const { t } = useTranslation();
  const {
          contactButtonName,
          getVacanciesList,
          headImage,
          vacanciesIsLoaded,
          isIndexed,
          items: vacancies,
          inCatalogLabel,
          inCatalogLink,
          label,
          loading: vacanciesLoading,
          meta:    {
                     title,
                     meta: {
                             canonical,
                             description,
                             keywords,
                           },
                   },
          template,
        }     = useVacancies();

  useEffect(() => {
    if (!vacanciesLoading && !vacanciesIsLoaded) {
      void getVacanciesList();
    }

    if (!isSSR()) {
      scrollTo({
        top:  0,
        left: 0,
      });
    }
  }, []);

  if (vacanciesIsLoaded && DV.isNull(label) && DV.isNull(headImage)) {
    return <Notfound />;
  }

  return (
    <>
      <div className={'page-content'}>
        <Meta
          canonical={canonical}
          description={description}
          isIndexed={isIndexed}
          keywords={keywords}
          title={title}
        />
        {DV.isNotEmptyString(label) && (
          <PageHeader
            transparent={true}
            bg={headImage}
          />
        )}
        {vacanciesIsLoaded && (
          <main className={template}>
            <section className={'vacancies-company'}>
              <h1>{label}</h1>
              <p>{t('vacancies.about_company')}</p>
            </section>
            <section>
              <div className={'vacancy-list'}>
                {DV.isNotEmptyArray(vacancies) && vacancies.map((vacancy, index) => (
                  <VacanciesItem
                    key={index}
                    vacancy={vacancy}
                  />
                ))}
              </div>
            </section>
            <section
              className={'vacancy-contacts'}
              dangerouslySetInnerHTML={{ __html: t('vacancies.contacts') }}
            />
            <section className={'to-catalog'}>
              <div className={'container'}>
                <RenderButton
                  type={'link'}
                  uri={inCatalogLink || '/vhodnye-dveri'}
                  label={inCatalogLabel || t('client_goToCatalog')}
                  className={'fill'}
                />
                <ContactUs label={contactButtonName} />
              </div>
            </section>
          </main>
        )}
      </div>
      {vacanciesLoading && (
        <Preloader />
      )}
    </>
  );
};

export default Vacancies;
